import React, { useEffect, useRef, useState } from "react";

export default function ScrollButtonMain() {
  const [activeSection, setActiveSection] = useState("hero");
  const prevSectionRef = useRef("hero");

  useEffect(() => {
    const sections = ["hero", "games", "contact"];

    const onScroll = () => {
      const scrollPos = window.scrollY + window.innerHeight / 2;
      let current = "hero";

      for (const id of sections) {
        const el = document.getElementById(id);
        if (!el) continue;
        const top = el.offsetTop;
        const height = el.offsetHeight;

        if (scrollPos >= top && scrollPos < top + height) {
          current = id;
          break;
        }
      }

      if (current !== activeSection) {
        prevSectionRef.current = activeSection;
        setActiveSection(current);
      }
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();

    return () => window.removeEventListener("scroll", onScroll);
  }, [activeSection]);

  const showDown = activeSection === "hero" || activeSection === "games";
  const showUp = activeSection === "games" || activeSection === "contact";

  const downTarget =
    activeSection === "hero"
      ? "games"
      : activeSection === "games"
      ? "contact"
      : null;

  const upTarget =
    activeSection === "games"
      ? "hero"
      : activeSection === "contact"
      ? "games"
      : null;

  const scaleFor8 = 1;
  const scaleFor5 = 0.62;
  const scaleFor0 = 0;

  let scaleValueDown = scaleFor0;
  let scaleValueUp = scaleFor0;

  if (activeSection === "hero") {
    scaleValueDown = scaleFor8;
    scaleValueUp = scaleFor0;
  } else if (activeSection === "games") {
    const prev = prevSectionRef.current;
    if (prev === "contact") {
      scaleValueUp = scaleFor8;
      scaleValueDown = scaleFor5;
    } else {
      scaleValueDown = scaleFor8;
      scaleValueUp = scaleFor5;
    }
  } else if (activeSection === "contact") {
    scaleValueUp = scaleFor8;
    scaleValueDown = scaleFor0;
  }

  const css = `
    @keyframes btnBounceDown { 
      0%,100% { transform: translateY(0); } 
      50% { transform: translateY(8px); } 
    }
    @keyframes btnBounceUp { 
      0%,100% { transform: translateY(0); } 
      50% { transform: translateY(-8px); } 
    }

    .scroll-btn-svg-down { 
      animation: btnBounceDown 1.5s ease-in-out infinite; 
      transform-origin: center; 
      display: block; 
    }
    .scroll-btn-svg-up { 
      animation: btnBounceUp 1.5s ease-in-out infinite; 
      transform-origin: center; 
      display: block; 
    }

    .scroll-btn-wrapper { transition: opacity 260ms ease; }
    .scroll-btn-scale { 
      transition: transform 320ms ease; 
      display: inline-block; 
      transform-origin: center; 
    }

    .scroll-btn-hidden { opacity: 0; pointer-events: none; }
    .scroll-btn-visible { opacity: 1; pointer-events: auto; }
  `;

  return (
    <>
      <style>{css}</style>
      <div className="hidden lg:block">
        <button
          aria-label={downTarget ? `Scroll down to ${downTarget}` : "No target"}
          className={`scroll-btn-wrapper fixed bottom-8 left-1/2 -translate-x-1/2 z-[20] 
                      bg-transparent border-none focus:outline-none 
                      ${showDown ? "scroll-btn-visible" : "scroll-btn-hidden"}`}
          onClick={() => downTarget && window.scrollDotsTo?.(downTarget)}
          tabIndex={showDown ? 0 : -1}
        >
          <span
            className="scroll-btn-scale"
            style={{ transform: `scale(${scaleValueDown})` }}
            aria-hidden
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              className="w-8 h-8 mx-auto opacity-90 hover:opacity-100 scroll-btn-svg-down"
              fill="none"
              stroke="white"
              strokeWidth="2"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </span>
        </button>
        <button
          aria-label={upTarget ? `Scroll up to ${upTarget}` : "No target"}
          className={`scroll-btn-wrapper fixed top-8 left-1/2 -translate-x-1/2 z-[20] 
                      bg-transparent border-none focus:outline-none 
                      ${showUp ? "scroll-btn-visible" : "scroll-btn-hidden"}`}
          onClick={() => upTarget && window.scrollDotsTo?.(upTarget)}
          tabIndex={showUp ? 0 : -1}
        >
          <span
            className="scroll-btn-scale"
            style={{
              transform: `scale(${scaleValueUp}) rotate(180deg)`,
              display: scaleValueUp === 0 ? "none" : "inline-block",
            }}
            aria-hidden
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              className="w-8 h-8 mx-auto opacity-90 hover:opacity-100 scroll-btn-svg-up"
              fill="none"
              stroke="white"
              strokeWidth="2"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </span>
        </button>
      </div>
    </>
  );
}

